module.exports = "<p>\n  test6 works!\n</p>\n"